import types from './types';

export const mutations = {
  [types.SET_FUNNELS_LOADING](state, data) {
    state.uiFlags.isFetching = data;
  },

  [types.SET_FUNNELS_CREATING](state, data) {
    state.uiFlags.isCreating = data;
  },

  [types.SET_FUNNELS_UPDATING](state, data) {
    state.uiFlags.isUpdating = data;
  },

  [types.SET_FUNNELS_DELETING](state, data) {
    state.uiFlags.isDeleting = data;
  },

  [types.SET_FUNNELS](state, data) {
    state.records = data.reduce((obj, funnel) => {
      obj[funnel.id] = funnel;
      return obj;
    }, {});
  },

  [types.SET_FUNNEL](state, data) {
    state.records[data.id] = data;
  },

  [types.DELETE_FUNNEL](state, funnelId) {
    delete state.records[funnelId];

    // Se o funil deletado era o selecionado, limpar seleção
    if (state.selectedFunnelId === funnelId) {
      state.selectedFunnelId = null;
    }
  },

  [types.UPDATE_FUNNEL](state, data) {
    if (state.records[data.id]) {
      state.records[data.id] = { ...state.records[data.id], ...data };
    }
  },

  [types.SET_SELECTED_FUNNEL](state, funnelId) {
    state.selectedFunnelId = funnelId;
  },

  [types.SET_FUNNEL_TEMPLATES](state, templates) {
    state.templates = templates;
  },

  [types.UPDATE_FUNNEL_STAGES](state, { funnelId, stages }) {
    if (state.records[funnelId]) {
      state.records[funnelId].stages = stages;
    }
  },

  [types.ADD_FUNNEL_STAGE](state, { funnelId, stageName, stageConfig }) {
    if (state.records[funnelId]) {
      const currentStages = state.records[funnelId].stages || {};
      state.records[funnelId].stages = {
        ...currentStages,
        [stageName]: stageConfig,
      };
    }
  },

  [types.REMOVE_FUNNEL_STAGE](state, { funnelId, stageName }) {
    if (state.records[funnelId] && state.records[funnelId].stages) {
      const stages = { ...state.records[funnelId].stages };
      delete stages[stageName];
      state.records[funnelId].stages = stages;
    }
  },

  [types.UPDATE_FUNNEL_STAGE](state, { funnelId, stageName, stageConfig }) {
    if (
      state.records[funnelId] &&
      state.records[funnelId].stages &&
      state.records[funnelId].stages[stageName]
    ) {
      state.records[funnelId].stages[stageName] = {
        ...state.records[funnelId].stages[stageName],
        ...stageConfig,
      };
    }
  },
};
